.container {
    max-width: 564px;
    padding: 48px 16px 16px;
    width: 100%;
    box-sizing: border-box;
    pointer-events: none;
}
